import Image from "next/legacy/image";
import { useRouter } from "next/router";
import ReactMarkdown from "react-markdown";
import { getButtonAppearance } from "utils/button";

import ButtonLink from "../elements/button-link";
import NextImage from "../elements/image";

import styles from "@/styles/app-block.module.scss";

const ProductHero = ({ data }) => {
  const router = useRouter();
  const isCurrentAccount = router.asPath === "/debit-account";
  return (
    <section>
      <div
        className={`grid grid-cols-1 max-w-1424 mx-auto md:grid-cols-12 md:pb-16 pt-0 md:pt-36 `}
      >
        <div
          className={`flex px-7 md:px-12 flex-col pb-16 gap-12 md:gap-14 col-span-6 ${
            isCurrentAccount
              ? "pt-16 pb-10 md:py-0 bg-onmoLightGrey md:bg-transparent md:px-0 md:pl-16"
              : ""
          }`}
        >
          <div className="flex flex-col gap-4">
            <h5 className={styles.productHeroSmallTitle}>{data.smallTitle}</h5>
            <h1
              className={`${styles.productHeroTitle} ${
                isCurrentAccount ? "max-w-[270px] md:max-w-[100%]" : ""
              }`}
              dangerouslySetInnerHTML={{ __html: data.title }}
            />
            <ReactMarkdown className={styles.productHeroDescription}>
              {data.description}
            </ReactMarkdown>
            <div className="flex flex-col gap-2.5">
              {data.IconFeatures.map((v, i) => (
                <div
                  key={i}
                  className={`flex items-center gap-1.5 ${styles.productTicks}`}
                >
                  {v.Icon === "Tick" ? (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7H0ZM6.60053 9.996L10.6307 4.95787L9.90267 4.37547L6.46613 8.66973L4.032 6.6416L3.43467 7.3584L6.60053 9.99693V9.996Z"
                        fill="#008675"
                      />
                    </svg>
                  ) : v.Icon === "APR" ? (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_54043_7498)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7Z"
                          fill="#008675"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4 5.43005C4 5.23114 4.07902 5.04038 4.21967 4.89972C4.36032 4.75907 4.55109 4.68005 4.75 4.68005C4.94891 4.68005 5.13968 4.75907 5.28033 4.89972C5.42098 5.04038 5.5 5.23114 5.5 5.43005C5.5 5.62897 5.42098 5.81973 5.28033 5.96038C5.13968 6.10104 4.94891 6.18005 4.75 6.18005C4.55109 6.18005 4.36032 6.10104 4.21967 5.96038C4.07902 5.81973 4 5.62897 4 5.43005Z"
                          fill="white"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.44995 9.09998C8.44995 8.90106 8.52897 8.7103 8.66962 8.56965C8.81027 8.42899 9.00104 8.34998 9.19995 8.34998C9.39886 8.34998 9.58963 8.42899 9.73028 8.56965C9.87093 8.7103 9.94995 8.90106 9.94995 9.09998C9.94995 9.29889 9.87093 9.48965 9.73028 9.63031C9.58963 9.77096 9.39886 9.84998 9.19995 9.84998C9.00104 9.84998 8.81027 9.77096 8.66962 9.63031C8.52897 9.48965 8.44995 9.29889 8.44995 9.09998Z"
                          fill="white"
                        />
                        <rect
                          x="8.57996"
                          y="4"
                          width="1"
                          height="7"
                          transform="rotate(35 8.57996 4)"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_54043_7498">
                          <rect width="14" height="14" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  ) : (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.92223 0C3.09955 0 0 3.13438 0 7C0 10.8656 3.09955 14 6.92223 14C10.7449 14 13.8445 10.8656 13.8445 7C13.8445 3.13438 10.7449 0 6.92223 0ZM9.6494 9.15156L9.20749 9.76094C9.19788 9.77421 9.18577 9.78542 9.17185 9.79395C9.15794 9.80247 9.1425 9.80812 9.12642 9.81059C9.11034 9.81306 9.09393 9.81229 9.07815 9.80833C9.06236 9.80437 9.0475 9.79729 9.03443 9.7875L6.47877 7.90312C6.46285 7.89156 6.44991 7.8763 6.44103 7.85863C6.43216 7.84095 6.42762 7.82138 6.42778 7.80156V3.5C6.42778 3.43125 6.48341 3.375 6.55139 3.375H7.2946C7.36259 3.375 7.41822 3.43125 7.41822 3.5V7.36719L9.62158 8.97812C9.67721 9.01719 9.68957 9.09531 9.6494 9.15156Z"
                        fill="#008675"
                      />
                    </svg>
                  )}
                  <p
                    className={`m-0 ${v.Icon === "APR" ? "font-medium" : null}`}
                  >
                    {v.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.buttonHolder}>
            {data.buttons.map((v, i) => (
              <ButtonLink
                key={i}
                updated
                size={v.size}
                button={v}
                appearance={getButtonAppearance(v.type)}
              />
            ))}
          </div>
          <div className={styles.smallText}>
            {data?.representativeExampleDisplay ? (
              <data.representativeExampleDisplay />
            ) : (
              data.smallText
            )}
          </div>
        </div>
        <div className="relative h-full w-full col-span-6 order-first md:order-last">
          <div
            className={`hidden md:block absolute f-full h-full top-[-100px] ${
              isCurrentAccount
                ? "left-20 lg:left-44 mt-[-100px]"
                : "ml-0 lg:ml-20"
            }`}
          >
            {data.image.data === null ? null : isCurrentAccount ? (
              data?.heroImageDesktop?.data === undefined ? null : (
                <Image
                  alt="Hero Debit Card Desktop"
                  src={data.heroImageDesktop.data.attributes.url}
                  width={isCurrentAccount ? "680" : "650"}
                  height={isCurrentAccount ? "700" : "585"}
                />
              )
            ) : (
              <NextImage
                media={data.image.data}
                className=""
                width={isCurrentAccount ? "680" : "650"}
                height={isCurrentAccount ? "700" : "585"}
              />
            )}
          </div>
          <div className={`"block md:hidden pt-10`}>
            {isCurrentAccount ? (
              data?.heroImageMobile?.data === undefined ? null : (
                <Image
                  alt="Hero Debit Card Mobile"
                  className="w-full"
                  width={"400"}
                  height={"300"}
                  src={data.heroImageMobile.data.attributes.url}
                />
              )
            ) : (
              <NextImage media={data.image.data} className="" />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductHero;
